/**
 * App Component
 * Main application entry point with routing
 */

import { AppRouter } from '@/routes';

function App() {
  return <AppRouter />;
}

export default App;
